import BrowserAlert from './browserAlert';

export default BrowserAlert;
